import React, { Component, useEffect, useRef, useState } from "react";
import {
  getCountryCallingCode,
  parsePhoneNumber,
} from "react-phone-number-input";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import VisibilitySensor from "react-visibility-sensor";
import SimpleReactValidator from "simple-react-validator";
import { store } from "../Services";
import { SendOTP } from "../Services/Actions/LoginSignupActions";
import {
  CheckAccount,
  IsSocialSignupFrom,
  SocialSignup,
} from "../Services/Actions/userActions";
import { withRouter } from "../Utils/withRouter";
import CommunicationSystem from "./communication";
import NxaFAQIndex from "./NxaFAQIndex";
import NxaVideoModal from "./NxaVideoModal";
import ScrollTestimonial from "./ScrollTestimonial";
import CTAButtons from "./ReuasbleComponets/CTAButtons";
import AsSeenOn from "./ReuasbleComponets/AsSeenOn";
import Companies from "./ReuasbleComponets/Companies";
import Leadmagnet from "./ReuasbleComponets/leadmagnet";
import HeroSlider from "./communication";
const { getName } = require("country-list");

const crm_links = [
  "None",
  "amoCRM",
  "Copper",
  "FLG",
  "Freshsales",
  "HubSpot",
  "Microsoft Dynamics",
  "noCRM.io",
  "Onpipeline",
  "Pipedrive",
  "Salesforce",
  "SugarCRM",
  "TeamGram",
  "Zendesk Sell",
  "Zoho CRM",
  "Sage One",
  "Xero Accounting ",
  "Excel",
  "Other",
];
const initialState = {
  openModal: false,
  firstname: "",
  lastname: "",
  company: "",
  email: "",
  phone: "",
  password: "",
  call_number: "",
  prefix: "",
  country_code: "",
  country: "",
  click: false,
  accessState: "",
  crm: "",
  affiliate_code: "",
  promotional_code: "",
};
const features = [
  {
    icon: "./../assets/images/new_index/Communication Solutions/world.svg",
    alt: "World Icon",
    title: "Access Local Numbers from 20+ Countries.  ",
    description: "Activate new numbers in   a matter of seconds.",
  },
  {
    icon: "./../assets/images/new_index/Communication Solutions/headphonesalt.svg",
    alt: "Headphone Icon",
    title: "Seamless Integration with MS Teams",
    description: "Enable direct calling within Microsoft Teams.",
  },
  {
    icon: "./../assets/images/new_index/Communication Solutions/phone.svg",
    alt: "Phone Icon",
    title: "AI-Powered Call Routing & IVR",
    description: "Automate call handling for faster response times.",
  },
  {
    icon: "./../assets/images/new_index/Communication Solutions/record.svg",
    alt: "Record Icon",
    title: "Secure Call Recording & Compliance",
    description: "Store and retrieve call logs with end-to-end encryption.",
  },
  {
    icon: "./../assets/images/new_index/Communication Solutions/messages.svg",
    alt: "Message Icon",
    title: "Unified Messaging Across Channels",
    description: "Manage SMS, WhatsApp, and team chat in one platform.",
  },
  {
    icon: "./../assets/images/new_index/Communication Solutions/phone-laptop.svg",
    alt: "Laptop Icon",
    title: " HD Video Meetings with Screen Sharing",
    description: "Host high-quality virtual meetings with no extra downloads.",
  },
  {
    icon: "./../assets/images/new_index/Communication Solutions/VoIP.svg",
    alt: "Voip Icon",
    title: "Scalable VoIP for Remote Teams",
    description: "Stay connected with crystal-clear calls anywhere.",
  },
  {
    icon: "./../assets/images/new_index/Communication Solutions/no contract.svg",
    alt: "Contract Icon",
    title: "No Contracts, Instant Activation",
    description: "Flexible plans with no long-term commitments.",
  },
  // Add 4 more items here
];
const steps = [
  {
    id: 1,
    title: "Choose Your Business Phone Number",
    image: "./../assets/images/new_index/Get Started/select-number.gif",
  },
  {
    id: 2,
    title: "Sign Up & Activate in Seconds",
    image: "./../assets/images/new_index/Get Started/doctor.webp",
  },
  {
    id: 3,
    title: "Start Making & Receiving Calls",
    image: "./../assets/images/new_index/Get Started/incomingcall.gif",
  },
  {
    id: 4,
    title: "Monitor Team Metrics in Real-Time",
    image: "./../assets/images/new_index/Get Started/monitorcalls.svg",
  },
];

export const VideoAutoPlay = () => {
  const videoRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isVisible) {
      videoRef.current.play();
    } else {
      if (videoRef.current.play) {
        videoRef.current.pause();
      }
    }
  }, [isVisible]);

  return (
    <VisibilitySensor onChange={(isVisible) => setIsVisible(isVisible)}>
      <video
        width="100%"
        height="100%"
        autoPlay={true}
        muted
        controls
        loop
        ref={videoRef}
      >
        <source
          src="./../assets/videos/nxatel_dreamers_new.mp4"
          type="video/mp4"
        />
      </video>
    </VisibilitySensor>
  );
};

class InnerHome extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      validators: {
        Phone: {
          required: true,
          message: "Please enter a valid number.",
          rule: (val, params, validatorP) => !!(val && val.length <= 9),
        },
      },
      messages: {
        in: "Password and Confirm Password must be same!",
      },
    });
    this.state = initialState;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.setState({ accessState: window.randomString(15, "aA#") });
    let chat = document.getElementById("zoho-chat-popup");
    chat &&
      chat.addEventListener("click", () => {
        window.$zohosq.floatwindow.open();
      });
  }

  componentWillUnmount() {
    let chat = document.getElementById("zoho-chat-popup");
    chat && chat.removeEventListener("click", () => {});
  }
  numberChange = (number) => {
    let phoneNumber = number ? parsePhoneNumber(number.toString()) : "";
    let prefix = "";
    let country_code = "";
    let call_number = "";
    let country = "";
    if (phoneNumber) {
      if (phoneNumber.nationalNumber && phoneNumber.country) {
        call_number = phoneNumber.nationalNumber.replace(/^0+/, "");
        country_code = phoneNumber.country;
        country = getName(country_code);
        if (getCountryCallingCode(phoneNumber.country)) {
          prefix = getCountryCallingCode(phoneNumber.country);
        }
      }
    }
    this.setState({
      call_number: call_number,
      prefix: prefix,
      country_code: country_code,
      country: country,
    });
  };

  onChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onEnterPress = (e) => {
    if (e.keyCode === 13) {
      this.handleSubmit();
    }
  };

  handleSubmit = async () => {
    const validator = this.validator;
    const {
      firstname,
      lastname,
      company,
      email,
      call_number,
      password,
      prefix,
      country,
      promotional_code,
      affiliate_code,
    } = this.state;
    const data = {
      firstname,
      lastname,
      email,
      password,
      phone: call_number,
      prefix,
      country,
      company,
      promotional_code,
      affiliate_code,
    };
    if (validator.allValid()) {
      this.setState({ click: true });
      let signup = await CheckAccount(data, store.dispatch);
      console.log(signup);
      if (signup.code === 1) {
        this.setState({ initialState });
        let {
          account_details: { phone, prefix },
        } = this.props;
        if (!phone) {
          this.props.navigate("/");
          return false;
        }
        prefix = prefix.includes("+") ? prefix : `+${prefix}`;
        // phone = `${prefix}${phone}`;

        let response = await SendOTP(
          { Number: phone, prefix: prefix },
          store.dispatch
        );
        if (response === 1) {
          this.props.navigate("/verify-number");
        } else {
          this.setState({ click: false });
          return false;
        }
      } else {
        this.setState({ click: false });
      }
    } else {
      validator.showMessages();
      this.forceUpdate();
    }
  };

  responseGoogle = (data) => {
    let profileObj = data?.profileObj;
    if (profileObj) {
      SocialSignup(profileObj, store.dispatch);
      IsSocialSignupFrom({ from: "nxa-page", with: "google" }, store.dispatch);
      this.props.navigate("/signup");
    }
  };

  _facebookLogin = () => {
    window.FB.getLoginStatus((response) => {
      if (response.status == "connected") {
        this.getCurrentFacebookUserInfo(response);
      } else {
        window.FB.login(
          (response) => {
            if (response.authResponse) {
              this.getCurrentFacebookUserInfo(response);
            }
          },
          { scope: "email" }
        );
      }
    });
  };

  getCurrentFacebookUserInfo() {
    window.FB.api("/me?fields=id,email,name", (userInfo) => {
      this.setState(
        {
          signUpWith: "facebook",
        },
        () => {
          SocialSignup(userInfo, store.dispatch);
          IsSocialSignupFrom(
            { from: "nxa-page", with: "facebook" },
            store.dispatch
          );
          this.props.navigate("/signup");
        }
      );
      if (Object.keys(userInfo).length) {
        window.FB.logout((response) => {
          console.log("logout response", response);
          // Person is now logged out
        });
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { social_signup: old_social_signup } = prevProps;
    const { social_signup } = this.props;
    if (social_signup && social_signup !== old_social_signup) {
      const { name, email } = social_signup;
      const [firstname, lastname] = name.split(" ");
      this.setState({ firstname, lastname, email });
    }
  }

  hidePop = () => {
    let element = document.getElementById("home-call-fixpop");
    element.classList.add("hide");
  };

  closeModal = () => {
    this.setState(
      {
        openModal: false,
      },
      () => {
        window.removeBackdrop();
      }
    );
  };

  render() {
    const {
      promotional_code,
      openModal,
      click,
      firstname,
      lastname,
      company,
      phone,
      email,
      password,
      call_number,
      affiliate_code,
    } = this.state;
    const { get_user_country: { country_code = "ZA" } = {} } = this.props;
    this.validator.purgeFields();
    return (
      <>
        {/* Pop Up */}
        <div
          className="home-call-popup home-call-fixpop bg--white z-index--9 p--15 radius--16 text-center w--min-290 "
          id="home-call-fixpop"
        >
          <div className="p--relative">
            <span
              className="close-popup"
              onClick={(e) => {
                this.hidePop();
                e.stopPropagation();
              }}
            >
              <img
                src={`${"./../assets/images"}/cross-add-modal.svg`}
                alt="1"
                className="h--25 w-auto c--pointer"
              />
            </span>
            <span className=" w--70 h--70 radius--50 overflow-hidden object-fit--cover bg--gray-f5 d-flex align-items-center justiffy-content-center m-auto border--4 border--orange">
              <img
                src={`${"./../assets/images"}/home-profile-img.svg`}
                alt="2"
              />
            </span>
            <div className="font--24 mt--8 mb--8 text--black sf--d-bold">
              Welcome to Nxatel
            </div>
            <div
              className="text--blue-1d3f font--16 bg--light-yellow pt--7 pb--7 pr--10 pl--10 radius--50 c--pointer sf--d-semibold"
              id="zoho-chat-popup"
            >
              Speak to our sales team
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  textAlign: "center",
                  flexDirection: "column",
                  marginLeft: "50px",
                }}
              >
                <div className="text--blue-1d3f font--16  dm--sans">
                  Call us on
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div className="text--blue-1d3f font--20 dm--sans fw--700">
                    086 169 2835
                  </div>{" "}
                </div>
              </div>
              <div>
                {" "}
                <a href="https://api.whatsapp.com/send/?phone=27672607763&text&type=phone_number&app_absent=0">
                  <img
                    src="..\assets\images\new_index\whatsapp.svg"
                    height={50}
                    width={50}
                    style={{
                      marginTop: "5px",
                      paddingLeft: "10px",
                    }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* main banner */}
        <section className="landing-hero">
          <div className="landing-hero__container">
            <div className="landing-hero__content">
              <h1>One Platform. Every Call, Message, Meeting — Simplified.</h1>
              <p>
                Stop missing important calls and messages. Get seamless,
                reliable business communication in one simple platform.
              </p>
              <div className="landing-hero__cta">
                <Link
                  className="see-nxatel"
                  to="#"
                  onClick={() => this.setState({ openModal: true })}
                  style={{ cursor: "pointer" }}
                >
                  <span>See NxaTel in Action</span>
                  <span className="see-nxatel__arrow">▶</span>
                </Link>

                <div className="landing-hero__button">
                  <CTAButtons />
                </div>
              </div>
            </div>
            <div className="landing-hero__image">
              <img
                className="landing-hero__image"
                src="./../assets/images/new_index/mainban.webp"
                alt="Lady participating in meeting"
                loading="lazy"
              />
            </div>
          </div>

          <div className="list-container">
            <ul>
              <li>No Setup Fees </li>
              <li>Cancel Anytime</li>
              <li> Instant Activation</li>
            </ul>
          </div>
        </section>
        {/* Communication system */}
        <section className="communication-system">
          <h1 className="heading-main">
            The Complete Communication System for Growing Your Business
          </h1>

          <HeroSlider />
        </section>

        {/* Get Started Section */}
        <section className="get-started-section">
          <div className="header">
            <h1>Get Started with NxaTel in Just 3 Minutes</h1>
            <p>
              No waiting. No complicated setup. Just plug, play, and start
              calling!
            </p>
          </div>
          <div className="steps-container">
            {steps.map((step) => (
              <div key={step.id} className="step-card">
                <div className="step-number">{step.id}</div>
                <img src={step.image} alt={step.title} className="step-image" />
                <h2>{step.title}</h2>
              </div>
            ))}
          </div>
          <div className="get-started__description">
            <p> No Setup Fees | Cancel Anytime | Instant Activation</p>
          </div>
          <div className="get-started__buttons">
            <CTAButtons />
          </div>
        </section>

        {/* One Platform, all communication needs */}
        <section className="oneplatform">
          <h1 className="oneplatform__heading">
            One Platform. All Your Communication Needs​
          </h1>
          <p className="oneplatform__subheading">
            No hardware. No hassle. Just seamless connectivity.
          </p>
          <h2 className="oneplatform__secheading"> Why Choose NxaTel?</h2>
          <div className="oneplatform__cards">
            <article className="oneplatform__card">
              <div className="oneplatform__card-image">
                <img
                  src="./../assets/images/new_index/One Platform/time icon.svg"
                  alt="Call Feature"
                  loading="lazy"
                />
              </div>
              <h3 className="oneplatform__card-title">
                No more implementation nightmares.
              </h3>
              <p className="oneplatform__card-text">
                With Nxatel, getting started is painless. There’s no special
                hardware to install, No waiting period.
              </p>
            </article>

            <article className="oneplatform__card">
              <div className="oneplatform__card-image">
                <img
                  src="./../assets/images/new_index/One Platform/contract.svg"
                  alt="Meet Feature"
                  loading="lazy"
                />
              </div>
              <h3 className="oneplatform__card-title">
                No Long-term commitments and flexible.
              </h3>
              <p className="oneplatform__card-text">
                With Nxatel there’s no contract and no long-term commitment.
                Scaling it’s a click away.
              </p>
            </article>

            <article className="oneplatform__card">
              <div className="oneplatform__card-image">
                <img
                  src="./../assets/images/new_index/One Platform/secure.svg"
                  alt="Message Feature"
                  loading="lazy"
                />
              </div>
              <h3 className="oneplatform__card-title">Secure & Reliable </h3>
              <p className="oneplatform__card-text">
                Enabling enterprise-grade security for businesses.
              </p>
            </article>
          </div>
        </section>
        {/* A Smarter, Simpler, and More Reliable Communication Solution section */}
        <section className="smarter-simpler-reliable">
          <h2 className="smarter-simpler-reliable__title">
            A Smarter, Simpler, and More Reliable Communication Solution
          </h2>
          <p className="smarter-simpler-reliable__subheading">
            Over 50+ powerful features designed to empower sales, support teams
            and your business customer service processes​
          </p>
          <div className="smarter-simpler-reliable__grid">
            {features.map((feature, index) => (
              <div key={index} className="smarter-simpler-reliable__item">
                <div className="smarter-simpler-reliable__icon-container">
                  <img
                    src={feature.icon}
                    alt={feature.alt}
                    className="smarter-simpler-reliable__icon"
                  />
                </div>
                <h3 className="smarter-simpler-reliable__feature-title">
                  {feature.title}
                </h3>
                <p className="smarter-simpler-reliable__feature-description">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
          <div className="smarter-simpler-reliable__description">
            <span>
              {" "}
              ​Preconfigured and ready to use, if you need them ​​ Need IP
              phones?
            </span>
            <p>
              {" "}
              We’ve got you covered. Shop for IP devices to use with your Nxatel
              service ​
            </p>
          </div>
          <div className="smarter-simpler-reliable__buttons">
            <CTAButtons />
          </div>
        </section>

        {/* Testimonial Section */}

        <section className="landing-testimonial">
          <h1>Join 1,000+ Businesses on Our Award-Winning Platform.</h1>
          <div className="landing-testimonial__image">
            <img
              className="landing-testimonial__nedbank"
              src="./../assets/images/new_index/nedbank.svg"
              alt="NedBank Logo"
              loading="lazy"
            />
          </div>
          <div className="landing-testimonial__companies">
            <Companies />
          </div>
          <h2>Real Businesses. Real Success Stories</h2>
          <div className="landing-testimonial__scroller">
            <ScrollTestimonial />
          </div>

          <h2>As Seen On</h2>
          <AsSeenOn />
        </section>
        {/* LEADMAGNET */}
        {/* <Leadmagnet /> */}
        {/* Dreamers section */}
        <section className="dreamer">
          <div className="dreamer-container">
            <div className="dreamer-content">
              <h1>Made for the dreamers.​ Like you.​</h1>
              <p>
                See NxaTel in action.​ Discover how the NxaTel can help you grow
                your business like never before.​
              </p>
              <div className="dreamer-button">
                <CTAButtons />
              </div>
            </div>

            <div className="virtual-video">
              <div className="video-box">
                <VideoAutoPlay />
              </div>
            </div>
          </div>
        </section>
        {/*  Explore products section */}
        <section className="products">
          <h1 className="products__heading">Explore our products​</h1>
          <p className="products__subheading">
            Get everything to keep your team and customer conversation on one
            easy system.​
          </p>
          <div className="products__cards">
            <article className="products__card">
              <div className="products__card-image">
                <img
                  src="./../assets/images/new_index/call.webp"
                  alt="Call Feature"
                  loading="lazy"
                />
              </div>
              <h3 className="products__card-title">Call</h3>
              <p className="products__card-text">
                Cloud phone system with 50+ robust features
              </p>
            </article>

            <article className="products__card">
              <div className="products__card-image">
                <img
                  src="./../assets/images/new_index/meet.webp"
                  alt="Meet Feature"
                  loading="lazy"
                />
              </div>
              <h3 className="products__card-title">Meet</h3>
              <p className="products__card-text">
                HD video meeting solution with screen sharing
              </p>
            </article>

            <article className="products__card">
              <div className="products__card-image">
                <img
                  src="./../assets/images/new_index/message.webp"
                  alt="Message Feature"
                  loading="lazy"
                />
              </div>
              <h3 className="products__card-title">Message</h3>
              <p className="products__card-text">
                Seamless team messaging with files, tasks, and more
              </p>
            </article>

            <article className="products__card">
              <div className="products__card-image">
                <img
                  src="./../assets/images/new_index/storage.webp"
                  alt="Store Documents Feature"
                  loading="lazy"
                />
              </div>
              <h3 className="products__card-title">Store Documents</h3>
              <p className="products__card-text">
                SMS and team messaging with collaborative tools, tasks, and more
              </p>
            </article>
          </div>
          <div className="smarter-simpler-reliable__buttons">
            <CTAButtons />
          </div>
        </section>

        {/* Map Section */}
        <section className="landing-map">
          <h1 className="landing-map__title">
            Access Numbers in over<span> 25+ countries</span>
          </h1>

          <div className="landing-map__image-container">
            <img
              className="landing-map__image"
              src="./../assets/images/new_index/map.webp"
              alt="Answering Messages"
              loading="lazy"
            />
          </div>
          <p className="landing-map__description">
            No Setup Fees | Cancel Anytime | Instant Activation
          </p>
          <div className="landing-map__button-container">
            <CTAButtons />
          </div>
        </section>

        <NxaFAQIndex />

        {openModal && (
          <NxaVideoModal openModal={openModal} closeModal={this.closeModal} />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    social_signup: state?.users?.social_signup ?? {},
    account_details: state?.users?.check_account ?? {},
    get_user_country: state?.users?.get_user_country ?? {},
  };
};

export default connect(mapStateToProps)(withRouter(InnerHome));
